import bigCursorIcon from "../icons/bigCursorIcon.svg"
import stopAnimationsIcon from "../icons/stopAnimationsIcon.svg"
import readingGuideIcon from "../icons/readingGuideIcon.svg"


export default [
    {
        label: 'Big Cursor',
        key: 'big-cursor',
        icon: bigCursorIcon,
    },
    {
        label: 'Stop Animations',
        key: 'stop-animations',
        icon: stopAnimationsIcon,
    },
    {
        label: 'Reading Guide',
        key: 'readable-guide',
        icon: readingGuideIcon,
    },
]